import { ApiKy } from './index'
import {
  GetActivityLogsParams,
  GetActivityLogsResponse,
} from '~/types/activity-logs'

export default class Api extends ApiKy {
  getActivityLogs(params: GetActivityLogsParams = {}) {
    return this.ky
      .get(this.url, { searchParams: params })
      .json<GetActivityLogsResponse>()
  }
}
